import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=9c0d1e3a&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c0d1e3a')) {
      api.createRecord('9c0d1e3a', component.options)
    } else {
      api.reload('9c0d1e3a', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=9c0d1e3a&", function () {
      api.rerender('9c0d1e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Kpz1URqTuh3J/JS/comp/childrenage.vue"
export default component.exports